export enum ReceiverType {
    PRIVATE_PERSON = "PRIVATE_PERSON",
    PUBLIC_INSTITUTION = "PUBLIC_INSTITUTION",
    PRIVATE_COMPANY = "PRIVATE_COMPANY",
    FROM_FILE = "FROM_FILE",
}

export enum UpdateKeyListBillReceivers {
    TODO = "TODO",
}

export type ImportBillReceiversFormValues = Readonly<{
    receiverType: ReceiverType
    updateKey: UpdateKeyListBillReceivers
    updateMatching: boolean
    deleteUnmatched: boolean
    file: null | Blob
}>
